import * as React from "react";
import { DataLayer } from "@grandvisionhq/analytics";
import { isContactLensVariant } from "@grandvisionhq/fun-products";
import { createImpressionEvent, createInteractionEvent } from "@grandvisionhq/products";
import { useIntl } from "@grandvisionhq/state";
import { withLazyLoading, replaceWhitespace } from "@grandvisionhq/utils";
import { useAlgoliaSearch } from "../../Algolia/hooks/Algolia/hooks/use-algolia-search.js";
import { AlgoliaCrossSellProducts } from "./AlgoliaCrossSellProducts.js";
import { getGraphAlgoliaFilters } from "../utils/CrossSellProducts/utils/get-graph-algolia-filters.js";
const GraphCrossSellProducts = ({
  activeVariant,
  product,
  algoliaConfig
}) => {
  const { facets } = algoliaConfig;
  const activeSku = activeVariant.sku;
  const { currency, locale, getLabel } = useIntl();
  const { filters, optionalFilters } = React.useMemo(
    () => getGraphAlgoliaFilters(product, activeVariant, facets, activeSku, locale),
    [product, facets, activeSku, locale]
  );
  const searchOptions = React.useMemo(() => {
    const lensRules = [];
    if (isContactLensVariant(activeVariant)) {
      activeVariant.replacementFrequency && lensRules.push(`cs-${replaceWhitespace(activeVariant.replacementFrequency, "_")}`);
      activeVariant.lensType && lensRules.push(`cs-${replaceWhitespace(activeVariant.lensType, "_")}`);
    }
    const ruleContexts = [
      ...lensRules,
      `cs-${product.productType.toLowerCase()}`,
      `cs-${activeSku}`,
      `cs-${replaceWhitespace(product.brandName, "_")}`
    ];
    return {
      filters,
      optionalFilters,
      hitsPerPage: 10,
      ruleContexts
    };
  }, [filters, optionalFilters, product.productType, activeSku, activeVariant]);
  const { result, isLoading, hasError } = useAlgoliaSearch(algoliaConfig, searchOptions);
  const isVisible = result.length > 0 && !isLoading && !hasError;
  const showLoader = result.length === 0 && isLoading;
  const handleImpression = React.useCallback(
    (product2, position) => {
      DataLayer.pushEvent(
        createImpressionEvent(product2, position, "cross-sell recommendation pdp", currency)
      );
    },
    [currency]
  );
  const handleInteraction = React.useCallback(
    (product2, position) => {
      DataLayer.pushEvent(
        createInteractionEvent(product2, position, "cross-sell recommendation pdp", currency)
      );
    },
    [currency]
  );
  return showLoader || isVisible ? /* @__PURE__ */ React.createElement(
    AlgoliaCrossSellProducts,
    {
      title: getLabel("products.crossSell.title"),
      result,
      isLoading,
      handleImpression,
      handleInteraction
    }
  ) : null;
};
const GraphCrossSellProducts$1 = withLazyLoading(GraphCrossSellProducts);
export {
  GraphCrossSellProducts$1 as default
};
//# sourceMappingURL=GraphCrossSellProducts.js.map
